module.exports = __webpack_public_path__ + "img/vertical_3_7_8004.f67d15a5.png";